// extracted by mini-css-extract-plugin
module.exports = {"Main":"OffSiteStockingItemClearInput_Main__2mJv0"};